import { string, bool, instanceOf, number } from 'prop-types'
import { useEffect, useRef } from 'react'

import Post from '../../../../models/Post.js'

export default function Video({
  post,
  autoPlay = false,
  controls = false,
  className = 'bzfy-c-autoplay-video',
  videoClassName = 'bzfy-gate-preview-autoplay-video',
  mediaIndex = 0,
}) {
  // Currently React does not guarantee to always render the muted attribute of a video tag in Safari on ios.
  // See issue here: https://github.com/facebook/react/issues/10389
  // However according to this article: https://stackoverflow.com/questions/61510160/why-muted-attribute-on-video-tag-is-ignored-in-react
  // the video will be muted correctly, but the property will not always be set in the DOM.
  // Update 26/07/24: seems like audio still creates some issues https://favro.com/organization/04fc50a713a8aa808e75d2b0/ceee5aa337be3d6e3163a4b3?card=flo-28303

  const videoRef = useRef(null)
  const mediaVideo = post.media[mediaIndex]

  // Potential workaround for audio being on on some devices for a couple of seconds
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.defaultMuted = true
      videoRef.current.muted = true
    }
  }, [])

  if (!mediaVideo?.isValid) {
    return null
  }

  const w = window.innerWidth
  let containerWidth
  let containerHeight

  if (w >= 1400) {
    containerHeight = '600px'
    containerWidth = '1200px'
  } else if (w < 1400 && w >= 1200) {
    containerHeight = '400px'
    containerWidth = '1000px'
  } else if (w < 1200 && w >= 1000) {
    containerHeight = '300px'
    containerWidth = '800px'
  } else if (w < 1000 && w >= 800) {
    containerHeight = '380px'
    containerWidth = '760px'
  } else {
    containerHeight = 'auto'
    containerWidth = '100%'
  }

  return (
    <div className={className}>
      <video
        ref={videoRef}
        autoPlay={autoPlay}
        className={videoClassName}
        controls={controls}
        height={containerHeight}
        loop
        muted
        playsInline
        src={mediaVideo.getUrl()}
        width={containerWidth}
      />
    </div>
  )
}

Video.propTypes = {
  autoPlay: bool,
  className: string,
  controls: bool,
  mediaIndex: number,
  post: instanceOf(Post).isRequired,
  videoClassName: string,
}
